var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "M18.58 5.131l.289.29a3.875 3.875 0 010 5.472l-2.778 2.778a3.843 3.843 0 01-2.732 1.133 3.882 3.882 0 01-2.74-1.132l-.29-.29a3.943 3.943 0 01-.394-.461.8.8 0 111.294-.942c.07.095.148.187.232.272l.29.29c.514.513 1.251.75 1.971.633a2.25 2.25 0 001.237-.634l2.778-2.779a2.272 2.272 0 000-3.209l-.289-.289a2.272 2.272 0 00-3.21 0L12.502 8a.8.8 0 11-1.131-1.131l1.736-1.736a3.874 3.874 0 015.472 0zM9.763 17.735L11.5 16a.8.8 0 011.131 1.132l-1.736 1.736a3.856 3.856 0 01-2.736 1.131c-.991 0-1.982-.377-2.736-1.131l-.29-.29A3.843 3.843 0 014 15.842c0-1.034.402-2.005 1.133-2.737l2.778-2.777a3.842 3.842 0 012.11-1.083 3.879 3.879 0 013.362 1.083l.29.289c.144.144.276.299.394.46a.8.8 0 01-1.294.942 2.278 2.278 0 00-.232-.27l-.289-.29a2.28 2.28 0 00-1.972-.635c-.47.077-.899.297-1.237.635l-2.778 2.778a2.255 2.255 0 00-.665 1.605c0 .606.236 1.175.665 1.604l.29.29a2.272 2.272 0 003.209 0z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "592980d53638c62c0c5f2eae6f34254d.svg";
export { SvgLinkIcon as ReactComponent };